/* ========================================
   SLIDESHOW ENGINE (rezim) — drives both
   image + product slideshows. Self-init for
   every [data-slideshow] on the page.
   ======================================== */
(function () {
  'use strict';

  function initOne(root) {
    if (root.dataset.ssReady === '1') return;
    root.dataset.ssReady = '1';

    var track = root.querySelector('[data-ss-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-ss-slide]'));
    if (slides.length === 0) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ss-dot]'));
    var prevBtn = root.querySelector('[data-ss-prev]');
    var nextBtn = root.querySelector('[data-ss-next]');
    var counterEl = root.querySelector('[data-ss-counter-current]');

    var autoplay = root.dataset.ssAutoplay === 'true';
    var interval = parseInt(root.dataset.ssInterval, 10) || 5000;
    var loop = root.dataset.ssLoop !== 'false';
    var index = 0;
    var timer = null;
    var count = slides.length;

    /* Cards visible per view (paged dots). Read from data attrs so it never
       mis-measures during init/customizer. Falls back to 1 (full-width slides). */
    var perD = parseInt(root.dataset.ssPerD, 10) || 1;
    var perM = parseInt(root.dataset.ssPerM, 10) || 1;
    function perView() {
      if (count < 2) return 1;
      var isDesktop = !window.matchMedia || window.matchMedia('(min-width: 768px)').matches;
      return Math.max(1, isDesktop ? perD : perM);
    }
    function pageCount() {
      return Math.max(1, Math.ceil(count / perView()));
    }

    /* Show only the dots we need (1 per page); hide the rest. */
    function syncDots() {
      var pages = pageCount();
      dots.forEach(function (d, di) {
        d.style.display = di < pages ? '' : 'none';
      });
    }

    function slideOffset(i) {
      return slides[i].offsetLeft - slides[0].offsetLeft;
    }
    function maxScroll() {
      var vp = track.parentElement;
      return Math.max(0, track.scrollWidth - vp.clientWidth);
    }

    function go(i) {
      if (loop) {
        index = (i + count) % count;
      } else {
        index = Math.max(0, Math.min(i, count - 1));
      }
      var target = slideOffset(index);
      var max = maxScroll();
      if (target > max) target = max;
      track.style.transform = 'translateX(' + (-target) + 'px)';
      var pv = perView();
      var activePage = Math.round(index / pv);
      dots.forEach(function (d, di) {
        d.setAttribute('aria-current', di === activePage ? 'true' : 'false');
      });
      slides.forEach(function (s, si) {
        if (si === index) s.setAttribute('aria-current', 'true');
        else s.removeAttribute('aria-current');
      });
      if (counterEl) {
        counterEl.textContent = (index + 1 < 10 ? '0' : '') + (index + 1);
      }
      if (!loop) {
        if (prevBtn) prevBtn.disabled = index === 0;
        if (nextBtn) nextBtn.disabled = target >= max;
      }
    }

    function next() {
      if (loop && maxScroll() > 0 && slideOffset(index) >= maxScroll() - 1) {
        go(0);
        return;
      }
      go(index + 1);
    }
    function prev() { go(index - 1); }

    function start() {
      if (!autoplay || count < 2) return;
      stop();
      timer = setInterval(next, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { go(di * perView()); start(); });
    });

    /* Pause on hover (desktop) */
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    /* Touch swipe (mobile) */
    var startX = 0, dx = 0, touching = false;
    track.addEventListener('touchstart', function (e) {
      touching = true; startX = e.touches[0].clientX; dx = 0; stop();
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!touching) return; dx = e.touches[0].clientX - startX;
    }, { passive: true });
    track.addEventListener('touchend', function () {
      touching = false;
      if (Math.abs(dx) > 40) { if (dx < 0) next(); else prev(); }
      start();
    });

    /* Keyboard (when focused) */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { next(); start(); }
      else if (e.key === 'ArrowLeft') { prev(); start(); }
    });

    go(0);
    syncDots();
    start();

    /* Re-sync paged dots + position on resize (debounced) */
    var rt = null;
    window.addEventListener('resize', function () {
      if (rt) clearTimeout(rt);
      rt = setTimeout(function () { syncDots(); go(index); }, 150);
    });

    /* Respect reduced motion */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stop();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-slideshow]').forEach(initOne);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  /* Re-init in Shopify theme editor when sections reload */
  document.addEventListener('shopify:section:load', initAll);
})();
